/* Окно повторного подтверждения фактора: макета у него нет — сетка как у окон журнала. */

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(420px, 100%);
}

.text {
  margin: 0;
  color: var(--text-secondary);
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

/* Что именно подтверждается — первой строкой и заметно (ТЗ 01, §595). */
.purpose {
  margin: 0;
  font-weight: var(--font-weight-semibold);
  color: var(--text-brand);
}
